import { Controller } from "@hotwired/stimulus"

// Toggle a menu and close it on outside click or Escape.
//
// <div data-controller="dropdown" data-action="keydown.esc@window->dropdown#close">
//   <button type="button" data-action="click->dropdown#toggle">Open</button>
//   <div data-dropdown-target="menu" class="hidden">...</div>
// </div>
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.close()
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    if (this.hasMenuTarget) this.menuTarget.classList.add("hidden")
  }

  hideOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
